export default __webpack_public_path__ + "static/media/logo-sumbar.0e258a95.svg";